import React from "react";
import ParentComponent from "./ParentComponentSelectAndMap";
import "flag-icons/css/flag-icons.min.css";
import "leaflet/dist/leaflet.css";

function App() {
  return (
    <div className="App">
      <ParentComponent />
    </div>
  );
}

export default App;
